import { render, staticRenderFns } from "./Tooltip.md?vue&type=template&id=7675c39a&"
import script from "./Tooltip.md?vue&type=script&lang=js&"
export * from "./Tooltip.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7675c39a')) {
      api.createRecord('7675c39a', component.options)
    } else {
      api.reload('7675c39a', component.options)
    }
    module.hot.accept("./Tooltip.md?vue&type=template&id=7675c39a&", function () {
      api.rerender('7675c39a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/doc/plugins/Tooltip.md"
export default component.exports